import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { OrgScopeProvider } from "../../contexts/dashboard-context/OrgScopeContext";
import {
  OrgDashboardProvider,
  useOrgDashboardContext,
} from "../../contexts/dashboard-context/OrgDashboardContext";
import { useToast } from "../../contexts/toast-context";
import OrganizationDashboard from "./index";
import OrganizationDashboardDetails from "./OrganizationDashboardDetails/organizationDashboardDetails";
import {
  ORGANIZATION_DASHBOARD_BASE,
  ORGANIZATION_DASHBOARD_PATHS,
} from "./OrganizationDashboardDetails/organizationDashboardDetailsConfig";

/**
 * OrgScopeProvider (outermost) holds the selected org ID shared across all
 * sub-routes. OrgDashboardProvider (inner) reads from OrgScopeContext and
 * auto-refetches when the admin changes org.
 */
const OrganizationDashboardRoutes: React.FC = () => (
  <OrgScopeProvider>
    <OrgDashboardProvider>
      <DashboardErrorToast />
      <Switch>
        <Route
          exact
          path={ORGANIZATION_DASHBOARD_PATHS.federationDetails}
          component={OrganizationDashboardDetails}
        />
        <Route
          exact
          path={ORGANIZATION_DASHBOARD_PATHS.organizationDetails}
          component={OrganizationDashboardDetails}
        />
        <Route
          exact
          path={ORGANIZATION_DASHBOARD_PATHS.adserverDetails}
          component={OrganizationDashboardDetails}
        />
        <Route exact path={ORGANIZATION_DASHBOARD_BASE} component={OrganizationDashboard} />
      </Switch>
    </OrgDashboardProvider>
  </OrgScopeProvider>
);

// Surfaces org dashboard fetch failures (e.g. 403 for an org the user can't
// access) as a toast instead of leaving them silent in the network tab —
// lives here rather than in each page so it fires regardless of which
// org-dashboard sub-route is active.
const DashboardErrorToast: React.FC = () => {
  const { error } = useOrgDashboardContext();
  const { showToast } = useToast();

  useEffect(() => {
    if (error) showToast(error, "error");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return null;
};

export default OrganizationDashboardRoutes;
